import React, { Component } from 'react';
import LoadingBar from '../../components/global/loadingBar';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as UploadIcon } from '../../../assets/svg/upload-cloud.svg';
import UploadFilesForRemap from '../../components/adminTools/uploadFilesForRemap';
import InputHeader from '../../components/global/inputwithHeader';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import _ from 'lodash';

const remapEquipment = gql`
	mutation ReMapEquipment($type: String!, $newQrCode: String!, $oldQrCode: String) {
		reMapEquipment(type: $type, newQrCode: $newQrCode, oldQrCode: $oldQrCode) {
			message
		}
	}
`;
const getEquipment = gql`
	query EquipmentList($eqIdentifier: [String!]!) {
		equipmentInfo(eqIdentifier: $eqIdentifier) {
			id
			qrCode
			ownerType
			ownerId
			type
			comment {
				_id
				comment
				createdAt
				createdBy
			}
			model
			description
			manufacturer
			manufacturerId
			status
			lastUsedBy {
				tenantId
				workspaceId
				projectId
				projectName
				projectSlNo
				eventId
				eventName
				eventSlNo
				userId
				userName
				usedAt
			}
			createdBy
			createdAt
			updatedBy
			updatedAt
			branch {
				_id
				branchId
			}
		}
	}
`;
class RemapEquipment extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: false,
			newQrCode: '',
			oldQrCode: '',
			isEQFetching: false,
			qrCodeError: false,
			eqFetched: false,
			equipments: {},
			note: '',
			beforeFileCount: 0,
			afterFileCount: 0,
			uploadBeforeFiles: false,
			uploadAfterFiles: false,
			beforeFiles: [],
			afterFiles: [],
			isAPILoading: false,
		};
	}
	isDisabled = () => {
		if (
			this.state.newQrCode == '' ||
			this.state.oldQrCode == '' ||
			(this.state.newQrCode &&
				this.state.oldQrCode &&
				this.state.newQrCode === this.state.oldQrCode) ||
			this.state.newQrCode.length < 8 ||
			this.state.oldQrCode.length < 8 ||
			this.state.isAPILoading === true
		) {
			return true;
		} else {
			return false;
		}
	};
	handleRemapEquipment = () => {
		let json;
		json = {
			type: this.state.equipments.type,
			newQrCode: this.state.newQrCode,
			oldQrCode: this.state.oldQrCode,
		};
		if (_.size(this.state.beforeFiles) > 0 || _.size(this.state.afterFiles) > 0) {
			json.files = [...this.state.beforeFiles, ...this.state.afterFiles];
		}
		this.remapEquipment(remapEquipment, json);
	};
	handleQrCode = (e, type) => {
		if (type === 'oldQrCode') {
			this.setState({
				eqFetched: false,
				qrCodeError: false,
				isEQFetching: false,
			});
		}
		this.setState(
			{
				[type]: e.target.value,
			},
			async () => {
				if (type === 'oldQrCode' && e.target.value.length >= 8) {
					let json = { eqIdentifier: e.target.value };

					await this.getEquipmentInfo(getEquipment, json, null, true);
				}
			},
		);
	};
	updateFileCount = (count, type) => {
		this.setState({
			[`${type}FileCount`]: count,
		});
	};
	uploadFileCompleted = (files, type) => {
		if (type === 'before') {
			if (this.state.afterFileCount > 0) {
				this.setState({
					uploadAfterFiles: true,
					beforeFiles: files,
				});
			} else {
				this.setState(
					{
						beforeFiles: files,
					},
					() => {
						this.handleRemapEquipment();
					},
				);
			}
		}
		if (type === 'after') {
			this.setState(
				{
					afterFiles: files,
				},
				() => {
					this.handleRemapEquipment();
				},
			);
		}
	};
	render() {
		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div
						className="assign-receive-container"
						style={{ width: '100%', marginLeft: 0 }}
					>
						<div className="arc-header">
							<div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div>
							<div className="arch-item">
								<span>Admin Tools</span>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>

							<div className="arch-item">
								<span>Remapping Equipment</span>
							</div>
							<div className="actn-btn">
								<a
									onClick={(e) => {
										if (!this.isDisabled()) {
											/* this.setState({
												isAPILoading: true,
											}); */
											if (false && this.state.beforeFileCount > 0) {
												this.setState({ uploadBeforeFiles: true });
											} else if (false && this.state.afterFileCount > 0) {
												this.setState({ uploadAfterFiles: true });
											} else {
												this.handleRemapEquipment();
											}
										}
									}}
									className={this.isDisabled() ? 'isDisabledBtn' : ''}
								>
									Remap Equipment
								</a>
							</div>
						</div>
						<div className="arc-body">
							<div className="remap-equipment-container">
								<div className="rec-left">
									<InputHeader
										type="text"
										name="oldQrCode"
										isInputError={false}
										label="Enter QR Code (old)"
										value={this.state.oldQrCode}
										width="100%"
										onChange={(e) => this.handleQrCode(e, 'oldQrCode')}
										readOnly={this.state.isAPILoading}
									/>

									{/* {this.state.oldQrCode !== '' &&
									this.state.qrCodeError !== true &&
									this.state.eqFetched ? ( */}
									<InputHeader
										type="text"
										name="newQrCode"
										isInputError={false}
										label="Enter QR Code (new)"
										value={this.state.newQrCode}
										width="100%"
										onChange={(e) => this.handleQrCode(e, 'newQrCode')}
										readOnly={this.state.isAPILoading}
									/>
									{/* ) : (
										''
									)} */}
									<div className="notes-container">
										<div className="notes-header">Notes</div>
										<textarea
											placeholder="Type here...."
											onChange={(e) => this.set({ note: e.target.value })}
											value={this.state.note}
											disabled={this.state.isAPILoading}
										/>
									</div>
									<div className="remap-eq-summary">
										{this.state.isEQFetching ? (
											'Loading...'
										) : this.state.eqFetched ? (
											this.state.qrCodeError == false ? (
												<>
													<b>Old Qr Code Details:</b>
													<a>
														Description :{' '}
														<b>{this.state.equipments.description}</b>
													</a>
													<a>
														Manufacturer :{' '}
														<b>{this.state.equipments.manufacturer}</b>
													</a>
													<a>
														Model : <b>{this.state.equipments.Modal}</b>
													</a>
													<a>
														Status :{' '}
														<b>{this.state.equipments.status}</b>
													</a>
													<a>
														Type : <b>{this.state.equipments.type}</b>
													</a>
												</>
											) : (
												<p>Equipment Not Found</p>
											)
										) : (
											''
										)}
									</div>
									{/* <InputHeader
										type="text"
										name="projectCode"
										isInputError={false}
										label="Notes"
										value={''}
										width="100%"
										textarea={true}
										rows={5}
									/> */}
								</div>
								<div className="rec-right">
									{/* <div className="remap-upload-outer">
										<div className="upload-header">BEFORE PHOTO</div>
										<div className="remap-upload-container">
											<span className="cloud-icn">
												<UploadIcon />
											</span>
											<span className="middle-text">
												Drag your images here
											</span>
											<span className="bottom-text">
												or Browse from your computer{' '}
											</span>
										</div>
									</div>
									<div className="remap-upload-outer">
										<div className="upload-header">AFTER PHOTO</div>
										<div className="remap-upload-container">
											<span className="cloud-icn">
												<UploadIcon />
											</span>
											<span className="middle-text">
												Drag your images here
											</span>
											<span className="bottom-text">
												or Browse from your computer{' '}
											</span>
										</div>
									</div> */}
									{/* <UploadFilesForRemap
										updateFileCount={(count) =>
											this.updateFileCount(count, 'before')
										}
										branchId={
											_.size(this.state.equipments) > 0 &&
											this.state.equipments.branch &&
											this.state.equipments.branch.branchId
												? this.state.equipments.branch.branchId
												: null
										}
										uploadTitle="BEFORE PHOTO"
										uploadFileCompleted={(files) =>
											this.uploadFileCompleted(files, 'before')
										}
										isLoading={this.state.isAPILoading}
										triggerFileUpload={this.state.uploadBeforeFiles}
									/>
									<UploadFilesForRemap
										updateFileCount={(count) =>
											this.updateFileCount(count, 'after')
										}
										branchId={
											_.size(this.state.equipments) > 0 &&
											this.state.equipments.branch &&
											this.state.equipments.branch.branchId
												? this.state.equipments.branch.branchId
												: null
										}
										uploadTitle="AFTER PHOTO"
										uploadFileCompleted={(files) =>
											this.uploadFileCompleted(files, 'after')
										}
										isLoading={this.state.isAPILoading}
										triggerFileUpload={this.state.uploadAfterFiles}
									/> */}
								</div>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}

export default withRouter(RemapEquipment);
